import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import InformationSection from '@/scopes/destinations/components/InformationSection'

export default function FlightInformation() {
  const intl = useIntl()
  const richText = useCMSPageField('DestinationPage.flightInformation')

  if (!richText)
    return null

  return (
    <InformationSection html={richText} title={intl.formatMessage({ id: 'destination_flight_information_title' })} />
  )
}
